import React, { useState, useEffect } from 'react'
import Header from './HeaderContainer'
import FooterContainer from './FooterContainer'
import Sidebar from '../../components/layout/Sidebar'
import FoodDetailsModal from '../food/FoodDetailsModal'
import FoodChoiceModal from '../food/FoodChoiceModal'

import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { toggleLoginForm } from '../../actions/appActions'
import { logout } from '../../actions/accountActions'
import { StorageKeys } from '../../constants'
import { getObjectData } from '../../utils/localStorageHelper'
import AddressMgrContainer from '../user/AddressMgrContainer'

const MasterLayout = ({ children }) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [isOpenSidebar, setIsOpenSidebar] = useState(false)
    const [isOpenAdrMgr, setIsOpenAdrMgr] = useState(false)
    const user = useSelector(state => state.AccountReducer.user)
    const restaurantInfo = useSelector(state => state.RestaurantReducer)

    const toggleSidebar = () => {
        setIsOpenSidebar(prev => !prev)
    }

    const showLogin = () => {
        setIsOpenSidebar(false)
        dispatch(toggleLoginForm(true))
    }

    const handleLogout = () => {
        setIsOpenSidebar(false)
        dispatch(logout())
    }

    useEffect(() => {
        isOpenSidebar && toggleSidebar()
    }, [location.pathname])

    if (!restaurantInfo || (getObjectData(StorageKeys.userData) && !user)) {
        return null
    }

    return (
        <>
            <Sidebar
                isOpen={isOpenSidebar}
                toggleSidebar={toggleSidebar}
                toggleAdrMgr={setIsOpenAdrMgr}
                showLogin={showLogin}
                handleLogout={handleLogout}
                user={user}
            />

            <FoodDetailsModal />

            <FoodChoiceModal />

            <Header
                toggleSidebar={toggleSidebar}
                toggleAdrMgr={setIsOpenAdrMgr}
            />

            <AddressMgrContainer
                isOpen={isOpenAdrMgr}
                toggleModal={setIsOpenAdrMgr}
            />

            {children}

            <FooterContainer />
        </>
    )
}

export default MasterLayout
